var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQiye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qiye_svg__clip0_1143_8016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.914.391a1.969 1.969 0 011.984 0l5.907 3.446c.604.352.976 1 .976 1.7v6.926c0 .7-.372 1.348-.976 1.7L9.898 17.61a1.969 1.969 0 01-1.984 0l-5.906-3.445c-.605-.353-.977-1-.977-1.701V5.537c0-.7.372-1.348.977-1.7L7.914.39z",
    fill: "url(#qiye_svg__paint0_linear_1143_8016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.955 9.832c6.189 0 11.206-3.345 11.206-7.47 0-4.127-5.017-7.471-11.206-7.471C2.767-5.11-2.25-1.765-2.25 2.36c0 4.126 5.017 7.471 11.205 7.471z",
    fill: "url(#qiye_svg__paint1_linear_1143_8016)",
    fillOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.682 4.875c-.97 1.078-2.192 1.974-3.657 2.688l.427.763c1.456-.771 2.636-1.684 3.523-2.746a11.275 11.275 0 003.49 2.738l.435-.763a11.764 11.764 0 01-3.632-2.68h-.586zm.134 2.232v4.355H7.41v-3.16h-.786v3.16H5.418v.763h7.013v-.763h-2.82V9.637h2.218v-.755H9.61V7.107h-.795z",
    fill: "#245BDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.81 5.254L9.232 2.067a.656.656 0 00-.651 0L3.003 5.254a.656.656 0 00-.331.57v6.352c0 .235.126.453.33.57l5.579 3.187c.201.115.45.115.65 0l5.579-3.187a.656.656 0 00.33-.57V5.824a.656.656 0 00-.33-.57zM9.557 1.497a1.313 1.313 0 00-1.302 0L2.677 4.685a1.313 1.313 0 00-.661 1.14v6.35c0 .472.252.907.66 1.14l5.58 3.188c.403.23.898.23 1.301 0l5.579-3.188c.409-.233.66-.668.66-1.14v-6.35c0-.472-.252-.907-.66-1.14L9.557 1.497z",
    fill: "#386BDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qiye_svg__paint0_linear_1143_8016",
    x1: 2.212,
    y1: 3.211,
    x2: 13.797,
    y2: 14.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qiye_svg__paint1_linear_1143_8016",
    x1: 8.955,
    y1: 11.077,
    x2: 8.955,
    y2: 5.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qiye_svg__clip0_1143_8016"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.031 .123)",
    d: "M0 0h15.75v17.754H0z"
  })))));
}
export default __webpack_public_path__ + "static/qiye.13d89e66.svg";
export { SvgQiye as ReactComponent };